const ReadyIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  const fillColor = isActive ? "#01BBFE" : "white";
  const backgroundFill = isActive ? "#68D7FF" : "#9EA6B2";
  const backgroundOpacity = isActive ? 0.2 : 0.3;
  const strokeGradientId = isActive ? "activeGradient" : "defaultGradient";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Background Circle */}
      <circle cx="28" cy="28" r="27" fill={backgroundFill} fillOpacity={backgroundOpacity} />
      <circle cx="28" cy="28" r="27" stroke={`url(#${strokeGradientId})`} strokeWidth="2" />

      {/* Check Mark + Star Path */}
      <g clipPath="url(#clipPath)">
        <path
          d="M28 16C21.3677 16 16 21.3672 16 28C16 34.6323 21.3672 40 28 40C34.6323 40 40 34.6328 40 28C40 21.3677 34.6328 16 28 16ZM25.1447 33.062C25.1447 33.062 20.9999 28.9156 20.7019 28.6182C20.0392 27.9554 20.0392 26.8769 20.7019 26.2147C21.3664 25.5503 22.441 25.5503 23.1054 26.2147L25.7887 28.898C26.1224 29.2317 26.6639 29.2294 26.9947 28.894L32.8864 22.9174C33.5486 22.2456 34.6306 22.241 35.2984 22.9089C35.956 23.5666 35.96 24.6406 35.3069 25.3033C28.9088 31.7949 27.6937 33.0615 27.6937 33.0615C26.9913 33.7638 25.8476 33.7645 25.1447 33.062Z"
          fill={fillColor}
        />
      </g>

      <defs>
        {/* Gradients */}
        <linearGradient id="defaultGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="activeGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#68D7FF" />
          <stop offset="1" stopColor="#68D7FF" stopOpacity="0" />
        </linearGradient>

        {/* Clipping */}
        <clipPath id="clipPath">
          <rect width="24" height="24" fill="white" transform="translate(16 16)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReadyIcon;
